import React from 'react';
import polyfillExternalSVGSymbol from './polyfillExternalSVGSymbol';
const SVGExternalUse = props => /*#__PURE__*/React.createElement("use", Object.assign({}, props, {
  href: polyfillExternalSVGSymbol(props.href)
}));
export default SVGExternalUse;